@if (!loading) {
  <mat-card appearance="outlined" class="vital-metrics-component">
    <div class="vital-metrics-card-header">
      <mat-card-title>
        <span>{{ 'ANALYTICS.VITAL_METRICS_MODAL.TITLE' | translate }}</span>
      </mat-card-title>
      <mat-card-subtitle>
        {{ 'ANALYTICS.VITAL_METRICS_MODAL.SUBTITLE' | translate }}
        {{ getScoreAgeText() }}
      </mat-card-subtitle>
      <div>
        <ng-content select=".header-content"></ng-content>
      </div>
    </div>
    <div class="chart-container">
      @if (!isError) {
        @if (!isEmpty) {
          <app-vital-metrics-table [sourceData]="tableData"></app-vital-metrics-table>
        } @else {
          <div class="no-data-container">
            {{ 'ANALYTICS.NO_DATA' | translate }}
          </div>
        }
      } @else {
        <div class="api-error-container">
          {{ 'ANALYTICS.FAILED_GET_DATA' | translate }}
        </div>
      }
    </div>
    <ng-container>
      <mat-card-actions>
        <button
          class="refresh footer"
          mat-button
          (click)="refreshButtonEvent($event)"
          [disabled]="refreshing"
          [matTooltip]="'ANALYTICS.VITAL_METRICS_MODAL.TOOLTIP.REFRESH_TOOLTIP' | translate"
          >
          <app-rotate-icon [imageUrl]="refreshImage" [animate]="refreshing"></app-rotate-icon>
        </button>
        <button class="footer" mat-button (click)="learnButtonEvent($event)">
          {{ 'BUTTONS.LEARN_MORE' | translate }}
        </button>
      </mat-card-actions>
    </ng-container>
  </mat-card>
} @else {
  <app-loading-state-card class="full-width-card" [header]="cardConfig.header"></app-loading-state-card>
}
